import { useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableSortLabel,
  TableHead,
  TableRow,
  Typography,
  Button,
  Badge,
  Box,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
export const SortableTableCell = ({
  property,
  children,
  orderBy,
  sortOrder,
  onClick,
  active,
}) => {
  return (
    <TableCell onClick={() => onClick(property)}>
      <TableSortLabel
        active={orderBy === property}
        direction={sortOrder}
        sx={{
          "& .MuiTableSortLabel-icon": {
            color: "rgba(0,114,206,255) !important",
          },
        }}
      >
        <Box sx={{ color: active ? "rgba(0,114,206,255)" : "inherit" }}>
          {children}
        </Box>
      </TableSortLabel>
    </TableCell>
  );
};
const SkillDetails = ({ courses, skillId }) => {
  const [sortOrder, setSortOrder] = useState("asc");
  const [orderBy, setOrderBy] = useState("id");
  const navigate = useNavigate();

  const handleSortClick = (property) => {
    const isAsc = orderBy === property && sortOrder === "asc";
    setSortOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };
  const sortedData = courses
    ? courses.sort((a, b) => {
        const order = sortOrder === "asc" ? 1 : -1;
        let aValue =
          orderBy === "CREATED_DT" ? new Date(a[orderBy]) : a[orderBy];
        let bValue =
          orderBy === "CREATED_DT" ? new Date(b[orderBy]) : b[orderBy];

        if (
          (aValue === null || aValue === undefined) &&
          (bValue === null || bValue === undefined)
        ) {
          return 1;
        }
        // Handle null or undefined values
        if (aValue === null || aValue === undefined) {
          return order;
        }
        if (bValue === null || bValue === undefined) {
          return -order;
        }

        // Normal string comparison
        if (aValue < bValue) {
          return -1 * order;
        }
        if (aValue > bValue) {
          return 1 * order;
        }
        return 0;
      })
    : [];

  const handleEdit = (skillId) => {
    navigate(`/skill-mappings/edit/${skillId}`);
  };

  return (
    <Box sx={{ ml: "22px", borderLeft: "1px solid #e0e0e0" }}>
      <Box sx={{ ml: "22px", mr: 2 }}>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Box display={"flex"} alignItems={"center"}>
            <Typography sx={{ fontSize: "18px" }}>
              Skill ID: {skillId}
            </Typography>
            <Badge
              badgeContent={courses?.length || 0}
              color="primary"
              sx={{ ml: 2 }}
            />
          </Box>
          <Button
            variant="contained"
            color="primary"
            onClick={() => handleEdit(skillId)}
            size="small"
          >
            Edit
          </Button>
        </Box>
        {/* <Alert severity="warning" sx={{mt:2}}>
  This Skill has additional requirements that are not listed here, Please contact your system administrator for more information.
</Alert> */}
        <TableContainer>
          <Box sx={{ maxHeight: "calc(100vh - 270px)", overflow: "auto" }}>
            <Table>
              <TableHead>
                <TableRow>
                  <SortableTableCell
                    property="COURSE_ID"
                    orderBy={orderBy}
                    sortOrder={sortOrder}
                    onClick={handleSortClick}
                    active={orderBy === "COURSE_ID"}
                  >
                    COURSE ID
                  </SortableTableCell>
                  <SortableTableCell
                    property="COURSE_NAME"
                    orderBy={orderBy}
                    sortOrder={sortOrder}
                    onClick={handleSortClick}
                    active={orderBy === "COURSE_NAME"}
                  >
                    COURSE NAME
                  </SortableTableCell>
                  <SortableTableCell
                    property="ONE_OF"
                    orderBy={orderBy}
                    sortOrder={sortOrder}
                    onClick={handleSortClick}
                    active={orderBy === "ONE_OF"}
                  >
                    ONE-OF
                  </SortableTableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {sortedData.map((row) => (
                  <TableRow key={row.COURSE_ID}>
                    <TableCell>{row.COURSE_ID}</TableCell>
                    <TableCell>{row.COURSE_NAME}</TableCell>
                    <TableCell>{row.ONE_OF}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </Box>
        </TableContainer>
      </Box>
    </Box>
  );
};

export default SkillDetails;
